import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useRedirect } from '../hooks/useRedirect';

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requiredRoles }) => {
  const { isAuthenticated, getUserRoles, isLoading } = useAuth();
  const location = useLocation();
  const { saveRedirectPath } = useRedirect();

  // Chỉ hiển thị loading khi đang thực hiện action (login, refresh, etc.)
  // Không hiển thị loading khi khởi tạo từ localStorage
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Đang xử lý...</p>
        </div>
      </div>
    );
  }

  // Nếu chưa đăng nhập, chuyển hướng đến trang đăng nhập
  if (!isAuthenticated) {
    // Lưu URL hiện tại để redirect sau khi đăng nhập
    saveRedirectPath();
    return <Navigate to="/auth/signin" state={{ from: location }} replace />;
  }

  // Kiểm tra quyền truy cập nếu có yêu cầu role cụ thể
  if (requiredRoles && requiredRoles.length > 0) {
    const userRoles = getUserRoles();
    const hasRequiredRole = requiredRoles.some(role => 
      userRoles.includes(role)
    );
    
    if (!hasRequiredRole) {
      return <Navigate to="/unauthorized" replace />;
    }
  } else {
    // Mặc định yêu cầu role admin cho tất cả các route private
    const userRoles = getUserRoles();
    if (!userRoles.includes('admin')) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
};

export default PrivateRoute;
